<template>
  <div :class="{section: true, intro: true, mobile: mobile()}">
    <h1 class="headline"><b>Weihnachten</b> zeigt uns, dass einfache Leute wie wir bei Gott eine so große Rolle spielen,
      dass er sich selbst ganz klein macht, um mit uns auf Augenhöhe zu kommen.</h1>
    <img class="tree" src="@/assets/christmas/Christmas_Tree.svg">
    <img class="scroll" src="@/assets/christmas/scroll.svg" @click="$emit('next')">

    <div class="imprintContainer">
      <router-link :to="{name: 'impressum'}" class="imprint">Impressum</router-link>
      <router-link :to="{name: 'datenschutz'}" class="imprint">Datenschutz</router-link>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import BasicComponent from "@/components/BasicComponent.js";

@Component()
export default class Intro extends BasicComponent {

  onActive() {

  }

  mounted() {
    this.register();
  }

}
</script>
<style scoped lang="scss">
@import "@/stylesheets/Christmas.scss";

$mobileBreakWidth: 1000px; // Switch to vertical arrangement

.intro {
  background-color: white;
  overflow: hidden !important;
  position: relative;

  .headline {
    color: black;
    font-size: 40px;
    font-weight: 300;

    width: 35%;
    max-width: 500px;
    //color: #000336;
    text-align: left;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(5vw, -50%);

    b {
      font-weight: 600;
      font-family: "Source Serif Pro";
    }

    @media screen and (max-width: 1200px) {
      font-size: 35px;
    }

    @media screen and (max-width: $mobileBreakWidth) {
      width: 80%;
      left: 50%;
      top: 75%;
      transform: translate(-50%, -50%);
      font-size: 30px;

      @media screen and (max-width: 600px) {
        font-size: 25px;
      }

      @media screen and (max-height: 700px) {
        top: 70%;
      }

      @media screen and (max-height: 600px) {
        font-size: 20px;
      }
    }
  }

  .tree {
    position: absolute;
    top: 0;
    right: 55%;
    height: 75vh;

    @media screen and (max-width: $mobileBreakWidth){
      height: auto;
      max-height: 50vh;
      width: 70vw;
      right: 50%;
      transform: translateX(50%);
      max-width: unset;
    }
  }

  .scroll {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 70px;
    z-index: 1010;

    &:hover {
      cursor: pointer;
    }
  }

  .imprintContainer {
    position: absolute;
    bottom: 10px;
    right: 10px;

    .imprint {
      font-size: 10px;
      margin-right: 10px;
    }

    .privacy {

    }
  }

}

.mobile {
  .title {
    font-size: 10vw;
    transform: translate(-50%, -50%);
    z-index: 200;
  }
}

</style>
